import React from "react";
import { VehicleTemplate } from "../../Templates/VehicleTempalte";

export const Vehicle = () => {
  return <VehicleTemplate />;
};
